import { Chart, registerables, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';

// Register plugins globally
Chart.register(
  ...registerables,
  ChartDataLabels,
  Tooltip,
  annotationPlugin
  //BoxPlotController,
  //BoxPlotChart,
  //ViolinController,
  //ViolinChart
);
